import { CenteredLoading, RestrictPlatform, twClassMerge } from '@healthhub/react-ui';
import { memo } from 'react';

import { envBaseUrl } from '@shared/configs/configs/config';
import { DEEP_LINKS } from '@shared/constants/deepLinks';
import { useLayoutViewContext } from '@shared/context';
import useServiceCatalog from '@shared/hooks/useServiceCatalog';

interface RestrictPlatformWrapperProps {
  children: React.ReactNode;
  serviceCatalogCode: string;
}

const RestrictPlatformWrapper = ({ children, serviceCatalogCode }: RestrictPlatformWrapperProps) => {
  const { isMobileView, isSharedServiceView, isStandardView, isPortalView } = useLayoutViewContext();
  const { getService, isLoading } = useServiceCatalog(!serviceCatalogCode);

  const serviceCatalog = getService(serviceCatalogCode);

  if (isLoading) {
    return (
      <div
        className={twClassMerge(
          'h-full',
          (isMobileView || isStandardView || isSharedServiceView) && 'h-dvh -mt-mobileHeader'
        )}
      >
        <CenteredLoading fullScreen={false} />
      </div>
    );
  }
  const isRestricted =
    (isMobileView && serviceCatalog?.RestrictPlatform === 'NATIVE') ||
    (isPortalView && serviceCatalog?.RestrictPlatform === 'WEB');

  if (!isRestricted) {
    return children;
  }

  return (
    <RestrictPlatform
      deepLinkUrl={`${envBaseUrl()}${DEEP_LINKS.openApp}`}
      isRestricted={isRestricted}
      layoutView={{ isMobileView }}
    />
  );
};

export default memo(RestrictPlatformWrapper);
